/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { Utilisateur } from 'app/models/utilisateur.model';

let user: Utilisateur;
if (localStorage.getItem('user'))
    user = JSON.parse(localStorage.getItem('user'));

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
        roles: 'ADMIN,USER,AGENT'
    },
    {
        id: 'abonnement',
        title: 'Abonnement',
        type: 'basic',
        icon: 'iconsmind:students',
        link: '/abonnement/consultation',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'abonne',
        title: 'Abonné',
        type: 'basic',
        icon: 'iconsmind:business_manwoman',
        link: '/abonnes',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'seance',
        title: 'Séance',
        type: 'basic',
        icon: 'iconsmind:business_manwoman',
        link: '/seance',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'utilisateur',
        title: 'utilisateur',
        type: 'basic',
        icon: 'heroicons_solid:users',
        link: '/utilisateur',
        roles: 'USER,ADMIN'
    },
    {
        type: 'divider',
        roles: 'USER,ADMIN,AGENT'
    }
];


defaultNavigation.push(
    {
        type: 'divider'
    })

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
        roles: 'ADMIN,USER,AGENT'
    },
    {
        id: 'facturation',
        title: 'Abonnement',
        type: 'basic',
        icon: 'iconsmind:students',
        link: '/abonnement/consultation',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'abonne',
        title: 'Abonné',
        type: 'basic',
        icon: 'iconsmind:business_manwoman',
        link: '/abonnes',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'seance',
        title: 'Séance',
        type: 'basic',
        icon: 'iconsmind:business_manwoman',
        link: '/seance',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'utilisateur',
        title: 'utilisateur',
        type: 'basic',
        icon: 'heroicons_solid:users',
        link: '/utilisateur',
        roles: 'USER,ADMIN'
    },
    {
        type: 'divider',
        roles: 'USER,ADMIN,AGENT'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
        roles: 'ADMIN,USER,AGENT'
    },
    {
        id: 'facturation',
        title: 'Abonnement',
        type: 'basic',
        icon: 'iconsmind:students',
        link: '/abonnement/consultation',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'abonne',
        title: 'Abonné',
        type: 'basic',
        icon: 'iconsmind:business_manwoman',
        link: '/abonnes',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'seance',
        title: 'Séance',
        type: 'basic',
        icon: 'iconsmind:business_manwoman',
        link: '/seance',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'utilisateur',
        title: 'utilisateur',
        type: 'basic',
        icon: 'heroicons_solid:users',
        link: '/utilisateur',
        roles: 'USER,ADMIN'
    },
    {
        type: 'divider',
        roles: 'USER,ADMIN,AGENT'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
        roles: 'ADMIN,USER,AGENT'
    },
    {
        id: 'facturation',
        title: 'Abonnement',
        type: 'basic',
        icon: 'iconsmind:students',
        link: '/abonnement/consultation',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'abonne',
        title: 'Abonné',
        type: 'basic',
        icon: 'iconsmind:business_manwoman',
        link: '/abonnes',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'seance',
        title: 'Séance',
        type: 'basic',
        icon: 'iconsmind:business_manwoman',
        link: '/seance',
        roles: 'USER,ADMIN,AGENT'
    },
    {
        id: 'utilisateur',
        title: 'utilisateur',
        type: 'basic',
        icon: 'heroicons_solid:users',
        link: '/utilisateur',
        roles: 'USER,ADMIN'
    },
    {
        type: 'divider',
        roles: 'USER,ADMIN,AGENT'
    }
];
